import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/dianying' },
  { name: '下载', path: '/#download' },
  { name: '会员', path: '/article/moguvideo-membership-guide' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const bgClass = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textClass = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-800';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass} ${scrolled ? 'shadow-sm' : ''}`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className={`ri-play-fill ${isHome && !scrolled ? 'text-primary-500' : 'text-background-50'} text-lg`}></i>
            </div>
            <span className={`font-heading font-bold text-lg whitespace-nowrap ${textClass}`}>
              蘑菇视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const isActive = item.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.path.split('#')[0]);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? isHome && !scrolled
                        ? 'bg-white/20 text-white'
                        : 'bg-primary-100 text-primary-700'
                      : isHome && !scrolled
                        ? 'text-white/80 hover:text-white hover:bg-white/10'
                        : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/article/moguvideo-membership-guide"
              className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all ${
                isHome && !scrolled
                  ? 'bg-white/20 text-white hover:bg-white/30'
                  : 'bg-primary-500 text-background-50 hover:bg-primary-600'
              }`}
            >
              开通会员
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${textClass}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => {
              const isActive = item.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.path.split('#')[0]);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  {item.name}
                </Link>
              );
            })}
            <Link
              to="/article/moguvideo-membership-guide"
              className="px-5 py-3 mt-2 rounded-full text-sm font-semibold bg-primary-500 text-background-50 text-center whitespace-nowrap"
            >
              开通会员
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}